import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: {},
    error: "",
    loginMessage: "",
    loginErrorMessage: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.GET_CONTENT_TYPE_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.GET_CONTENT_TYPE_SUCCESS: {
      const result = {
        FAQ: [],
        T_AND_C: "",
        privacy_policy: "",
      };
      result[action.response.data.type] = action.response.data;
      return {
        data: result,
        isProgress: false,
      };
    }
    case homeConstants.GET_CONTENT_TYPE_FAILURE:
      return {
        data: {},
        loginErrorMessage: action.response,
        isProgress: false,
      };
    default:
      return state;
  }
}
